<div class="sa-flex-container">
  <ng-container [formGroup]="locationForm">
    <div class="grid grid-cols-5 gap-1">
      <div class="flex flex-col form-field">
        <div class="form-field-label">
          Latitude
        </div>
        <mat-form-field appearance="outline">
          <input
            matInput
            type="number"
            formControlName="latitude"
            (blur)="handleLatitudeInputChange($event.target.value)"
          />
          <mat-error *ngIf="locationForm.get('latitude').hasError('required')">
            Input is required
          </mat-error>
          <mat-error
            *ngIf="
              locationForm.get('latitude').hasError('latitude') && !locationForm.get('latitude').hasError('required')
            "
          >
            Latitude value should be between -90 and 90
          </mat-error>
        </mat-form-field>
      </div>

      <div class="flex flex-col form-field">
        <div class="form-field-label">
          Longitude
        </div>
        <mat-form-field appearance="outline">
          <input
            matInput
            type="number"
            formControlName="longitude"
            saAutomatedSelector="well-creation__longitude"
            (blur)="handleLongitudeInputChange($event.target.value)"
          />
          <mat-error *ngIf="locationForm.get('longitude').hasError('required')">
            Input is required
          </mat-error>
          <mat-error
            *ngIf="
              locationForm.get('longitude').hasError('longitude') && !locationForm.get('longitude').hasError('required')
            "
          >
            Longitude value should be between -180 and 180
          </mat-error>
        </mat-form-field>
      </div>

      <div class="flex flex-col form-field">
        <div class="form-field-label">
          Radius (Miles)
        </div>
        <mat-form-field appearance="outline">
          <input
            matInput
            type="number"
            step="0.1"
            formControlName="radius"
            saAutomatedSelector="well-creation__radius"
          />
          <mat-error *ngIf="locationForm.get('radius').hasError('required')">
            Input is required
          </mat-error>
          <mat-error *ngIf="locationForm.get('radius').invalid && !locationForm.get('radius').hasError('required')">
            Value Must be between 0.01 and 10
          </mat-error>
        </mat-form-field>
      </div>

      <div><!--spacer--></div>

      <div class="flex flex-col justify-center">
        <mat-slide-toggle color="primary" formControlName="showOuterSite">Staging Geofence</mat-slide-toggle>
      </div>

      <ng-container
        *ngIf="
          locationForm.get('outerLatitude') && locationForm.get('outerLongitude') && locationForm.get('outerRadius')
        "
      >
        <div class="flex flex-col form-field">
          <div class="form-field-label">
            Staging Latitude
          </div>
          <mat-form-field appearance="outline">
            <input matInput type="number" formControlName="outerLatitude" />
            <mat-error *ngIf="locationForm.get('outerLatitude').hasError('required')">
              Input is required
            </mat-error>
            <mat-error
              *ngIf="
                locationForm.get('outerLatitude').hasError('outerLatitude') &&
                !locationForm.get('outerLatitude').hasError('required')
              "
            >
              Latitude value should be between -90 and 90
            </mat-error>
          </mat-form-field>
        </div>

        <div class="flex flex-col form-field">
          <div class="form-field-label">
            Staging Longitude
          </div>
          <mat-form-field appearance="outline">
            <input matInput type="number" formControlName="outerLongitude" />
            <mat-error *ngIf="locationForm.get('outerLongitude').hasError('required')">
              Input is required
            </mat-error>
            <mat-error
              *ngIf="
                locationForm.get('outerLongitude').hasError('outerLongitude') &&
                !locationForm.get('outerLongitude').hasError('required')
              "
            >
              Longitude value should be between -180 and 180
            </mat-error>
          </mat-form-field>
        </div>

        <div class="flex flex-col form-field">
          <div class="form-field-label">
            Staging Radius (Miles)
          </div>
          <mat-form-field appearance="outline">
            <input
              matInput
              placeholder="Staging Radius (Miles)"
              type="number"
              step="0.1"
              formControlName="outerRadius"
            />
            <mat-error *ngIf="locationForm.get('outerRadius').hasError('required')">
              Input is required
            </mat-error>
            <mat-error
              *ngIf="locationForm.get('outerRadius').invalid && !locationForm.get('outerRadius').hasError('required')"
            >
              Value Must be between 0 and 10
            </mat-error>
          </mat-form-field>
        </div>

        <div class="flex flex-col form-field">
          <div class="form-field-label">
            Staging Pad to Well Travel Minutes
          </div>
          <mat-form-field appearance="outline">
            <input
              matInput
              placeholder="Staging Pad to Well Travel Minutes"
              type="number"
              step="1"
              formControlName="minutesFromStagingPadToFrac"
            />
          </mat-form-field>
        </div>

        <div class="flex flex-col justify-center">
          <mat-slide-toggle formControlName="stagingRoadIsOneWay" color="primary"
            >Staging Road is One Way</mat-slide-toggle
          >
        </div>
      </ng-container>
    </div>
  </ng-container>

  <div class="sa-flex-row relative">
    <div class="sa-flex-col actions">
      <button type="button" mat-raised-button (click)="centerMarkerOnMap()">Center Marker On Map</button>
      <button type="button" mat-raised-button (click)="centerMapOnMarker()">Center Map On Marker</button>
    </div>
  </div>
  <div class="sa-flex-row map-row">
    <div #map class="map"></div>
  </div>
</div>
